import { GrowthDataSet } from '../../types/data-set.types';

// WHO Weight-for-age GIRLS
// Birth to 13 weeks (weekly measurements)
export const whoGirlsWeightWeekly: GrowthDataSet = {
  id: 'who-girls-weight-weekly',
  source: 'WHO',
  title: 'Weight-for-age',
  intervalType: 'week',
  gender: 'female',
  measurementType: 'weight',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'kg',
  dataPoints: [
    {
      age: 0,
      m: 3.2322,
      s: 0.14171,
      sd: 0.458,
      percentiles: {
        p1: 2.3,
        p3: 2.4,
        p5: 2.5,
        p15: 2.8,
        p25: 2.9,
        p50: 3.2,
        p75: 3.6,
        p85: 3.7,
        p95: 4.0,
        p97: 4.2,
        p99: 4.4,
      },
    },
    {
      age: 1, // Week 1
      m: 3.3388,
      s: 0.146,
      sd: 0.4874,
      percentiles: {
        p1: 2.3,
        p3: 2.5,
        p5: 2.6,
        p15: 2.9,
        p25: 3.0,
        p50: 3.3,
        p75: 3.7,
        p85: 3.9,
        p95: 4.2,
        p97: 4.4,
        p99: 4.6,
      },
    },
    {
      age: 2, // Week 2
      m: 3.5693,
      s: 0.14339,
      sd: 0.5118,
      percentiles: {
        p1: 2.5,
        p3: 2.7,
        p5: 2.8,
        p15: 3.1,
        p25: 3.2,
        p50: 3.6,
        p75: 3.9,
        p85: 4.1,
        p95: 4.5,
        p97: 4.6,
        p99: 4.9,
      },
    },
    {
      age: 3, // Week 3
      m: 3.8352,
      s: 0.1406,
      sd: 0.5392,
      percentiles: {
        p1: 2.7,
        p3: 2.9,
        p5: 3.0,
        p15: 3.3,
        p25: 3.5,
        p50: 3.8,
        p75: 4.2,
        p85: 4.4,
        p95: 4.8,
        p97: 5.0,
        p99: 5.3,
      },
    },
    {
      age: 4, // Week 4
      m: 4.0987,
      s: 0.13805,
      sd: 0.5658,
      percentiles: {
        p1: 2.9,
        p3: 3.1,
        p5: 3.3,
        p15: 3.5,
        p25: 3.7,
        p50: 4.1,
        p75: 4.5,
        p85: 4.7,
        p95: 5.1,
        p97: 5.3,
        p99: 5.6,
      },
    },
    {
      age: 5, // Week 5
      m: 4.3476,
      s: 0.13583,
      sd: 0.5905,
      percentiles: {
        p1: 3.1,
        p3: 3.3,
        p5: 3.5,
        p15: 3.8,
        p25: 4.0,
        p50: 4.3,
        p75: 4.8,
        p85: 5.0,
        p95: 5.4,
        p97: 5.6,
        p99: 5.9,
      },
    },
    {
      age: 6, // Week 6
      m: 4.5793,
      s: 0.13392,
      sd: 0.6133,
      percentiles: {
        p1: 3.3,
        p3: 3.5,
        p5: 3.7,
        p15: 4.0,
        p25: 4.2,
        p50: 4.6,
        p75: 5.0,
        p85: 5.3,
        p95: 5.7,
        p97: 5.9,
        p99: 6.2,
      },
    },
    {
      age: 7, // Week 7
      m: 4.795,
      s: 0.13228,
      sd: 0.6343,
      percentiles: {
        p1: 3.5,
        p3: 3.7,
        p5: 3.8,
        p15: 4.2,
        p25: 4.4,
        p50: 4.8,
        p75: 5.2,
        p85: 5.5,
        p95: 5.9,
        p97: 6.1,
        p99: 6.5,
      },
    },
    {
      age: 8, // Week 8
      m: 4.9959,
      s: 0.13087,
      sd: 0.6538,
      percentiles: {
        p1: 3.7,
        p3: 3.9,
        p5: 4.0,
        p15: 4.4,
        p25: 4.6,
        p50: 5.0,
        p75: 5.5,
        p85: 5.7,
        p95: 6.2,
        p97: 6.4,
        p99: 6.7,
      },
    },
    {
      age: 9, // Week 9
      m: 5.1842,
      s: 0.12966,
      sd: 0.6722,
      percentiles: {
        p1: 3.8,
        p3: 4.1,
        p5: 4.2,
        p15: 4.5,
        p25: 4.7,
        p50: 5.2,
        p75: 5.7,
        p85: 5.9,
        p95: 6.4,
        p97: 6.6,
        p99: 7.0,
      },
    },
    {
      age: 10, // Week 10
      m: 5.3618,
      s: 0.12861,
      sd: 0.6896,
      percentiles: {
        p1: 4.0,
        p3: 4.2,
        p5: 4.3,
        p15: 4.7,
        p25: 4.9,
        p50: 5.4,
        p75: 5.8,
        p85: 6.1,
        p95: 6.6,
        p97: 6.8,
        p99: 7.2,
      },
    },
    {
      age: 11, // Week 11
      m: 5.5295,
      s: 0.1277,
      sd: 0.7061,
      percentiles: {
        p1: 4.1,
        p3: 4.3,
        p5: 4.5,
        p15: 4.8,
        p25: 5.1,
        p50: 5.5,
        p75: 6.0,
        p85: 6.3,
        p95: 6.8,
        p97: 7.0,
        p99: 7.4,
      },
    },
    {
      age: 12, // Week 12
      m: 5.6883,
      s: 0.12691,
      sd: 0.7219,
      percentiles: {
        p1: 4.2,
        p3: 4.5,
        p5: 4.6,
        p15: 5.0,
        p25: 5.2,
        p50: 5.7,
        p75: 6.2,
        p85: 6.5,
        p95: 7.0,
        p97: 7.2,
        p99: 7.6,
      },
    },
    {
      age: 13, // Week 13
      m: 5.8393,
      s: 0.12622,
      sd: 0.737,
      percentiles: {
        p1: 4.3,
        p3: 4.6,
        p5: 4.7,
        p15: 5.1,
        p25: 5.4,
        p50: 5.8,
        p75: 6.4,
        p85: 6.7,
        p95: 7.2,
        p97: 7.4,
        p99: 7.8,
      },
    },
  ],
};
